var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main-inner',{attrs:{"title":"会员设置"}},[_c('member-level-table',{ref:"level",attrs:{"vendorId":_vm.userInfo.orgId,"callback":_vm.callback}}),_c('level-score-table',{ref:"score",attrs:{"vendorId":_vm.userInfo.orgId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }